"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InAppAgentToolInputsSchema = void 0;
exports.isInAppAgentToolWithInputs = isInAppAgentToolWithInputs;
exports.validateInAppAgentToolInputs = validateInAppAgentToolInputs;
const zod_1 = __importDefault(require("zod"));
const constants_1 = require("./constants");
const questionnaire_1 = require("./questionnaire");
/**
 * User input sent with a tool approval, keyed by the tool that consumes it.
 * The worker hands each tool its own entry as resume data.
 */
exports.InAppAgentToolInputsSchema = zod_1.default.strictObject({
    [constants_1.IN_APP_AGENT_QUESTIONNAIRE_TOOL_NAME]: zod_1.default
        .object({ answers: questionnaire_1.InAppAgentQuestionnaireAnswersSchema })
        .optional(),
});
// Checks the input against the tool call the model persisted, so the worker
// never resumes a tool with input that does not fit its arguments.
const toolInputValidators = {
    [constants_1.IN_APP_AGENT_QUESTIONNAIRE_TOOL_NAME]: ({ args, input }) => (0, questionnaire_1.resolveInAppAgentQuestionnaireAnswers)({ args, answers: input.answers }),
};
function isInAppAgentToolWithInputs(toolName) {
    return Object.hasOwn(toolInputValidators, toolName);
}
/**
 * Tool inputs are only accepted for an approved call of a tool that takes
 * input, and such a tool cannot be approved without them.
 */
function validateInAppAgentToolInputs(params) {
    const { toolName, args, approved, toolInputs } = params;
    const providedToolNames = Object.entries(toolInputs ?? {}).flatMap(([name, input]) => (input === undefined ? [] : [name]));
    const acceptsInput = approved && isInAppAgentToolWithInputs(toolName);
    if (providedToolNames.some((name) => !acceptsInput || name !== toolName)) {
        return {
            success: false,
            error: "Tool inputs are only accepted for the approved tool",
        };
    }
    if (!acceptsInput) {
        return { success: true };
    }
    const input = toolInputs?.[toolName];
    if (input === undefined) {
        return { success: false, error: "This tool requires input to approve" };
    }
    return toolInputValidators[toolName]({ args, input });
}
